import { makeStyles } from '@material-ui/core/styles';

/**
 * Shared styles for CGA Hierarchy Report components
 */
export const useCGAHierarchyStyles = makeStyles({
  clickableRow: {
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  headerSection: {
    marginBottom: '16px',
    padding: '16px',
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    borderRadius: '8px',
  },
  filterSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  userSearchSection: {
    marginBottom: '24px',
    padding: '20px',
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    borderRadius: '8px',
    border: '1px solid rgba(0, 0, 0, 0.08)',
  },
  searchRow: {
    marginBottom: '16px',
  },
  controlsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  selectedUserChip: {
    marginLeft: '8px',
    backgroundColor: 'rgba(103, 58, 183, 0.1)',
    borderRadius: '16px',
    padding: '4px 12px',
  },
  summaryCardsContainer: {
    marginBottom: '20px',
  },
  reportHeader: {
    marginBottom: '16px',
    flexWrap: 'wrap',
    padding: '14px 16px',
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
    borderRadius: '8px',
    border: '1px solid rgba(25, 118, 210, 0.12)',
  },
  summaryCard: {
    padding: '16px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    textAlign: 'center',
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  summaryCardValue: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  summaryCardLabel: {
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: '4px',
  },
  exportActionsGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
  primaryExportCard: {
    padding: '14px 16px',
    backgroundColor: 'rgba(46, 125, 50, 0.04)',
    borderRadius: '8px',
    border: '1px solid rgba(46, 125, 50, 0.18)',
  },
  primaryExportTitle: {
    fontWeight: 650,
    marginBottom: '4px',
  },
  primaryExportSubtitle: {
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  secondaryActionsGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
  progressSection: {
    marginTop: '16px',
    marginBottom: '16px',
    padding: '12px 16px',
    backgroundColor: 'rgba(103, 58, 183, 0.05)',
    borderRadius: '8px',
    border: '1px solid rgba(103, 58, 183, 0.2)',
  },
  progressStage: {
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: '4px',
  },
});
